import { render, staticRenderFns } from "./category-url.vue?vue&type=template&id=04b0aa42&"
import script from "./category-url.vue?vue&type=script&lang=js&"
export * from "./category-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports